// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__3B1xB","rotation":"preloader_rotation__35XDN","anim_rotation":"preloader_anim_rotation__Q5g_g"};